import { Scalars } from '@generated/base-types';
import { ManagerError } from '@new/common/utils/error-parser';
import {
  BookletType,
  ExamQuestionGroup,
  ExamQuestions,
  LockState
} from '@new/pools/lib/types';
import { PresortExamQuestionsMutationVariables } from '@new/pools/pool/lib/services/exam/presort-exam-questions.generated';
import { UpdateExamQuestionGroupsFragment } from '@new/pools/pool/lib/services/exam/update-exam-question-group-positions.generated';

/* Query actions */

export class LoadExamQuestionGroups {
  public static readonly type = '[ExamQuestionGroups] Load';
  constructor(public readonly examId: Scalars['ID']) {}
}

export class LoadExamQuestionGroupsSuccess {
  public static readonly type = '[ExamQuestionGroups] Load success';
  constructor(public readonly examQuestions: ExamQuestions) {}
}

export class LoadExamQuestionGroupsFailure {
  public static readonly type = '[ExamQuestionGroups] Load failure';
  constructor(public readonly error: ManagerError) {}
}

export class SetSelectedExamQuestionGroupIds {
  public static readonly type = '[ExamQuestionGroups] Set selected IDs';
  constructor(
    public readonly ids: ExamQuestionGroup['questionGroup']['id'][]
  ) {}
}

export class ResetSelectedExamQuestionGroupIds {
  public static readonly type = '[ExamQuestionGroups] Reset selected IDs';
}

export class ResetTableState {
  public static readonly type = '[ExamQuestionGroups] Reset table state';
}

export class SetSelectedBooklet {
  public static readonly type = '[ExamQuestionGroups] Set selected booklet';
  constructor(public readonly booklet: BookletType) {}
}

export class RefreshExamQuestionGroups {
  public static readonly type = '[ExamQuestionGroups] Refresh';
}

/* Mutation actions */

export class Failure {
  public static readonly type = '[ExamQuestionGroups] Mutation failure';
  constructor(
    public readonly error: ManagerError,
    public readonly validationMessage?: string
  ) {}
}

export class UpdateExamQuestionGroupPosition {
  public static readonly type = '[ExamQuestionGroups] Update position';
  constructor(
    public readonly oldPosition: number,
    public readonly newPosition: number
  ) {}
}

export class UpdateExamQuestionGroupPositionSuccess {
  public static readonly type = '[ExamQuestionGroups] Update position success';
  constructor(
    public readonly updatedExamQuestionsGroups: UpdateExamQuestionGroupsFragment[],
    public readonly afterDeletion: boolean = false
  ) {}
}

export class ApplySortingOfBookletAToBookletB {
  public static readonly type = '[ExamQuestionGroups] Apply sorting A to B';
}

export class ApplySortingOfBookletAToBookletBSuccess {
  public static readonly type =
    '[ExamQuestionGroups] Apply sorting A to B success';
  constructor(public readonly updatedExamQuestions: ExamQuestionGroup[]) {}
}

export class SetIcebreaker {
  public static readonly type = '[ExamQuestionGroups] Set icebreaker';
  constructor(public readonly questionGroupId: ExamQuestionGroup['id']) {}
}

export class SetIcebreakerSuccess {
  public static readonly type = '[ExamQuestionGroups] Set icebreaker success';
  constructor(public readonly updatedExamQuestionId: ExamQuestionGroup['id']) {}
}

export class PresortExamQuestions {
  public static readonly type = '[ExamQuestionGroups] Presort';
  constructor(
    public readonly presortInput: PresortExamQuestionsMutationVariables
  ) {}
}

export class PresortExamQuestionsSuccess {
  public static readonly type = '[ExamQuestionGroups] Presort success';
  constructor(public readonly examId: Scalars['ID']) {}
}

export class RemoveExamQuestion {
  public static readonly type = '[ExamQuestionGroups] Remove exam question';
  constructor(
    public readonly examQuestionId: number,
    public readonly positionAandB: { positionA: number; positionB: number }
  ) {}
}

export class RemoveExamQuestionSuccess {
  public static readonly type =
    '[ExamQuestionGroups] Remove exam question success';
  constructor(
    public readonly examQuestionId: number,
    public readonly positionAandB: { positionA: number; positionB: number }
  ) {}
}

export class UpdatePositionsAfterDeletion {
  public static readonly type =
    '[ExamQuestionGroups] Update positions after deletion';
  constructor(
    public readonly positionAandB: { positionA: number; positionB: number }
  ) {}
}

export class UpdateExamQuestionVersion {
  public static readonly type =
    '[ExamQuestionGroups] Update exam question version';
  constructor(public readonly examQuestionGroupId: number) {}
}

export class UpdateExamQuestionVersionSuccess {
  public static readonly type =
    '[ExamQuestionGroups] Update exam question version success';
  constructor(public readonly examQuestionGroupId: number) {}
}

export class UpdateExamQuestionGroupLockedState {
  public static readonly type = '[ExamQuestionGroups] Update locked state';
  constructor(
    public readonly examId: string,
    public readonly lockState: LockState
  ) {}
}

export class LoadExamQuestionGroupAssetMetadata {
  public static readonly type = '[ExamQuestionGroups] Load asset metadata';

  constructor(public readonly assetIds: string[]) {}
}
